/* eslint-disable react-hooks/exhaustive-deps */
import * as THREE from 'three'
import React, { useMemo } from 'react'
import { useThree } from '@react-three/fiber';

import { controls } from '../../../../../../../../redux/reducers/common/eventReducer';

import { delModel, extrudeSettings, roofPattern, textureAnisotropy } from '../../../../../../../../utils/Functions';
import { const_var, params } from '../../../../../../../../redux/reducers/reducer';
import { CSG } from '../../../../../../../../assets/libs/csg-lib';
import useMouseEvents from '../../../../../../../../hooks/useMouseEvents';
import { MaterialInnerWall, MaterialOuterWallNew, MaterialWainScotWallNew } from '../../../../../../CustomMaterial';
import { getSimilarTexture, textureAppliedFor } from '../../../../../../../../redux/reducers/utils';

const WallModel = () => {
    const { gl } = useThree ();

    const cbFrontBackWallOffset = 0.16;
    const wallThickness = 0.005;
    const railWidth = 0.2;
    
    const canvasElement = document.getElementsByClassName("buildingcanvas")
    const isPattern = (canvasElement != undefined && canvasElement[0]?.clientWidth > 1050 && !params.p_v_w) ? true : false

    const textureObj = useMemo(() => {
        let similarSidingTextures = getSimilarTexture(params.wallTexture)
        let similarWainscotTextures = getSimilarTexture(params.wainscotTexture)

        const texture = const_var.wallTextureObj?.[similarSidingTextures]?.clone();
        const wainscotTexture = const_var.wallTextureObj?.[similarWainscotTextures]?.clone();

        const metalTexture = const_var.wallTextureObj?.["vertical"]?.clone();
        const lightTexture = const_var.wallTextureObj?.["vertical_light"]?.clone();
        
        if(metalTexture){
            if (params.wallOrientation == "vertical") metalTexture.rotation = Math.PI/-2;
            else metalTexture.rotation = 0;
        }
        if(lightTexture) lightTexture.rotation = metalTexture.rotation;
        if(texture && const_var.selSidingOption == "metal") texture.rotation = metalTexture.rotation
        if(wainscotTexture && (params.wainscotTexture == "none" || params.wainscotTexture == "vertical")) wainscotTexture.rotation = metalTexture.rotation

        return {"texture":texture,"wainscotTexture" : wainscotTexture,"metalTexture":metalTexture,"lightTexture":lightTexture};
    }, [params.p_v_w, params.wallTexture, const_var.wallTextureObj, const_var.selSidingOption, params.wallOrientation,params.wainscotTexture]);

    const texture = useMemo(() => {
        if(const_var.metalTexture){
            let texture = const_var.metalTexture.clone();
            textureAnisotropy(gl, texture,1.3, 1.3, (params.p_v_w != true) ? 0 :  Math.PI/-2);    
            return texture
        }else{
            return null
        }
    }, [params.p_v_w,params.wallTexture,const_var.wallTextureObj[params.wallTexture]])

    let offset;
    
    const legDistance = useMemo(() => {
        return (const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined) ? const_var.DistanceArr[params.p_b_t][params.p_r_s] : 5
    }, [const_var.DistanceArr, params.p_b_t, params.p_r_s,params.fourth_center_cost,const_var.DistanceArr.length>0 && const_var.DistanceArr[params.p_b_t][params.p_r_s]!=undefined && const_var.DistanceArr[params.p_b_t][params.p_r_s]])

    if(params.leanB_p_d % legDistance === 0) offset = 0.15;
    else offset = 0;

    const wallPosoffset = useMemo(() => {
        if(params.backLeanStoragePosition > 0 && params.backLeanStoragePosition !== params.leanB_p_d - parseInt(params.add_storage_back) - railWidth) return railWidth;
        else return 0;
    }, [params.backLeanStoragePosition, params.leanB_p_d, params.add_storage_back])

    // Side Wall - CSG
    const sideWallModelObj = useMemo(() => {
        let outerModel;
        let innerModel;
        let wainscotModel;

        let verticalHorizontalPosS = {"x": params.leanB_p_d / 2,"y" : ((params.p_w_c_n && (params.p_b_c_b_b_l === 'Close' || params.add_storage_back)) ? 2.935 : 0), "z" : params.p_d / -2 - params.leanB_p_w - wallThickness - 0.16}
        let verticalHorizontalRotS = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}
        let patternLengthS = params.leanB_p_h + (params.p_r_s === 1 && 0.15) + ((params.p_w_c_n && (params.p_b_c_b_b_l === 'Close' || params.add_storage_back)) ? -2.935 : 0)
        let patternDepthS = params.leanB_p_d

        let lengthPatternS = 3
        let depthPatternS = patternDepthS

        let lengthOffset;
        if(params.backLeanStoragePosition === params.leanB_p_d - parseInt(params.add_storage_back) - railWidth) lengthOffset = 0.12;
        else lengthOffset = 0;

        //************************* */ inner wall geometry
        const sideWallModel = new THREE.Shape();
        sideWallModel.moveTo(-params.leanB_p_d / 2, 0);
        sideWallModel.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + lengthOffset + wallPosoffset + offset, 0);
        sideWallModel.lineTo(-params.leanB_p_d / 2 + parseInt(params.add_storage_back) + lengthOffset + wallPosoffset + offset, params.leanB_p_h + (params.p_r_s === 1 && 0.1));
        sideWallModel.lineTo(-params.leanB_p_d / 2, params.leanB_p_h + (params.p_r_s === 1 && 0.1));
        sideWallModel.closePath();

        const meshSideWallModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallModel, extrudeSettings(0.005)))
        const meshSideDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(delModel('backLeanSide', 'wall'), extrudeSettings(1)))
        
        let meshSideWallModel_Temp = meshSideWallModel.clone();
        meshSideWallModel_Temp.position.set(0, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset + 0.03);
        meshSideWallModel_Temp.updateMatrixWorld();
    
        let meshSideDelModel_Temp = meshSideDelModel.clone();
        // meshSideDelModel_Temp.position.set(alignPosOffset, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset - 0.5);
        meshSideDelModel_Temp.position.set(-params.leanB_p_pos - params.backLeanStoragePosition, 0, -params.p_d / 2 - params.leanB_p_w - cbFrontBackWallOffset - 0.5);
        meshSideDelModel_Temp.updateMatrixWorld();
        
    
        const meshSideWallModel_CSG = CSG.fromMesh(meshSideWallModel_Temp)
        const meshSideDelModel_CSG = CSG.fromMesh(meshSideDelModel_Temp)
    
        const sideWallModel_CSG = meshSideWallModel_CSG.subtract(meshSideDelModel_CSG)
        const CSGSideWallModel = CSG.toMesh(
            sideWallModel_CSG,
            new THREE.Matrix4()
        )

        innerModel = CSGSideWallModel.geometry;

        //************************* */ outer wall geometry
        
        const meshSideWallModelPattern = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(patternLengthS, isPattern), extrudeSettings(patternDepthS)));
        const meshWallDelModel = new THREE.Mesh(new THREE.ExtrudeGeometry(sideWallModel, extrudeSettings(1)))
        
        let meshWallModel_TempS = meshSideWallModelPattern.clone();
        meshWallModel_TempS.position.set(verticalHorizontalPosS.x,verticalHorizontalPosS.y,verticalHorizontalPosS.z);
        meshWallModel_TempS.rotation.set(verticalHorizontalRotS.x,verticalHorizontalRotS.y,verticalHorizontalRotS.z);
        meshWallModel_TempS.updateMatrixWorld();
    
    
        let meshWallDelModel_TempS = meshWallDelModel.clone();
        meshWallDelModel_TempS.position.set(0 , 0, params.p_d / -2 - params.leanB_p_w - 0.5);
        meshWallDelModel_TempS.updateMatrixWorld();
    
        const meshWallModel_CSGS = CSG.fromMesh(meshWallModel_TempS);
        const meshWallDelModel_CSGS = CSG.fromMesh(meshWallDelModel_TempS);
    
    
        const wallModel_CSGS = meshWallModel_CSGS.subtract(meshSideDelModel_CSG);
        const meshWallDel_CSGS = wallModel_CSGS.intersect(meshWallDelModel_CSGS);
        const CSGWallModelS = CSG.toMesh(meshWallDel_CSGS,new THREE.Matrix4());

        outerModel = CSGWallModelS.geometry

        //************************* */ wainscot wall geometry
        let wainscotVerticalHorizontalPosS = {"x": params.leanB_p_d / 2,"y" : 0, "z" : params.p_d / -2 - params.leanB_p_w - wallThickness - 0.16}
        let wainscotVerticalHorizontalRotS = {"x":0,"y" : Math.PI / -2,"z" : Math.PI / 2}

        const meshSideWainscotModel = new THREE.Mesh(new THREE.ExtrudeGeometry(roofPattern(lengthPatternS, isPattern), extrudeSettings(depthPatternS)))
        let meshSideWainscotModel_Temp = meshSideWainscotModel.clone();
        meshSideWainscotModel_Temp.position.set(wainscotVerticalHorizontalPosS.x,wainscotVerticalHorizontalPosS.y,wainscotVerticalHorizontalPosS.z);
        meshSideWainscotModel_Temp.rotation.set(wainscotVerticalHorizontalRotS.x,wainscotVerticalHorizontalRotS.y,wainscotVerticalHorizontalRotS.z);
        meshSideWainscotModel_Temp.updateMatrixWorld();

        const meshSideWainscotModel_CSG = CSG.fromMesh(meshSideWainscotModel_Temp);

        const SideWainscotModel_CSG = meshSideWainscotModel_CSG.subtract(meshSideDelModel_CSG);
        const SideWainscotModelCSG = SideWainscotModel_CSG.intersect(meshWallDelModel_CSGS);
        const CSGSideWainscotModel = CSG.toMesh(
            SideWainscotModelCSG,
            new THREE.Matrix4()
            )

        wainscotModel = CSGSideWainscotModel.geometry;

        return {outerModel, innerModel, wainscotModel}
        
    }, [params.wallTexture,params.p_b_c_b_b_l, wallPosoffset, offset, params.p_r_s, params.leanB_p_d, params.backLeanStoragePosition, params.leanB_p_h, params.add_storage_check_back, params.add_storage_back, params.p_w_c_n, params.p_d, cbFrontBackWallOffset, params.leanB_p_w, params.add_left_back_lean_porch, params.add_right_back_lean_porch, params.p_v_w, const_var.newDoorsArray, isPattern]);
    
    const handleMouseEvent = (e) => {
        if (controls.isCheckActiveTab === 'doorwindow' && (const_var.focusedSection === "backlean" && params.activeWall === "B_L_L_S_W")) {
            switch (e.type) {
                case 'pointerdown':
                case 'click':
                case 'pointermove':
                    e.stopPropagation();
                    break;
                default :
                    break
            }
        }
    };
    const eventHandlers = useMouseEvents(handleMouseEvent);

    return (
        <group name='back_lean_side_wall' {...eventHandlers}>
            {sideWallModelObj?.outerModel && 
                <mesh name="B_L_F_S_W" geometry={sideWallModelObj?.outerModel} renderOrder={1}>
                    <MaterialOuterWallNew isPattern={isPattern} visibleSection={"backLean"} />
                </mesh>
            }
            {params.p_w_c_n == true && sideWallModelObj?.wainscotModel &&
                <mesh name="B_L_F_S_W_wainscot" geometry={sideWallModelObj?.wainscotModel} position={[0,0,-0.005]} renderOrder={1}>
                    <MaterialWainScotWallNew isPattern={isPattern} visibleSection={"backLean"} />
                </mesh>
            }
            {sideWallModelObj && sideWallModelObj?.innerModel && 
                <mesh name="side" geometry={sideWallModelObj?.innerModel} position={[0, 0, wallThickness + 0.01]}>
                    <MaterialInnerWall texture={texture} visibleSection={"backLean"} />
                </mesh>
            }
        </group>
    )
}

export default WallModel